import * as React from 'react';
import { Form } from 'semantic-ui-react';

import {
    RutPasaporte,
    RutPasaporteDatos,
    rutPasaporteInicial,
} from 'src/modulos/Matriculas/IngresoNuevaMatricula/componentes/RutPasaporte';

import capitalizar from 'src/modulos/Matriculas/IngresoNuevaMatricula/utils/capitalizar';
import { mapStringToOptions } from 'src/modulos/Matriculas/IngresoNuevaMatricula/utils/mapStringToOptions';

import FechaNacimiento from './componentes/FechaNacimiento';

const estadosCiviles = [
    'Soltero(a)',
    'Casado(a)',
    'Viudo(a)',
    'Divorciado(a)',
    'Separado(a)',
    'Conviviente',
];

export interface Datos {
    id: RutPasaporteDatos;
    fechaNacimiento: string;
    estadoCivil: string;
    primerNombre: string;
    nombresSecundarios: string;
    apellidoPaterno: string;
    apellidoMaterno: string;
}

export const inicial: Datos = {
    id: { ...rutPasaporteInicial },
    fechaNacimiento: '',
    estadoCivil: '',
    primerNombre: '',
    nombresSecundarios: '',
    apellidoPaterno: '',
    apellidoMaterno: '',
};

interface Props {
    requeridos: boolean;
    personales: Datos;
    onChange(personales: Datos): void;
}

class Personales extends React.PureComponent<Props> {
    public render() {
        const { requeridos, personales, onChange } = this.props;

        return (
            <div>
                <Form.Group widths='2'>
                    <RutPasaporte
                        rutPasaporte={personales.id}
                        alCambiar={id => {
                            onChange({ ...personales, id });
                        }}
                        requerido={requeridos}
                    />
                    <FechaNacimiento
                        fecha={personales.fechaNacimiento}
                        alCambiar={fechaNacimiento => {
                            onChange({ ...personales, fechaNacimiento });
                        }}
                        requerido={requeridos}
                    />
                    <Form.Select
                        label='Estado civil'
                        options={mapStringToOptions(estadosCiviles)}
                        width='4'
                        value={personales.estadoCivil}
                        onChange={(_e, { value }) => {
                            onChange({ ...personales, estadoCivil: value as string });
                        }}
                    />
                </Form.Group>

                <Form.Group widths='equal'>
                    <Form.Input
                        label='Primer nombre'
                        placeholder='María'
                        value={personales.primerNombre}
                        onChange={(_e, { value }) => {
                            onChange({
                                ...personales,
                                primerNombre: capitalizar(value),
                            });
                        }}
                        required={requeridos}
                        fluid
                    />
                    <Form.Input
                        label='Nombres secundarios'
                        value={personales.nombresSecundarios}
                        onChange={(_e, { value }) => {
                            onChange({
                                ...personales,
                                nombresSecundarios: capitalizar(value),
                            });
                        }}
                        placeholder='Teresa De Las Mercedes'
                        fluid
                    />
                    <Form.Input
                        label='Apellido paterno'
                        placeholder='Pérez'
                        value={personales.apellidoPaterno}
                        onChange={(_e, { value }) => {
                            onChange({
                                ...personales,
                                apellidoPaterno: capitalizar(value),
                            });
                        }}
                        required={requeridos}
                        fluid
                    />
                    <Form.Input
                        label='Apellido materno'
                        placeholder='Carvajal'
                        value={personales.apellidoMaterno}
                        onChange={(_e, { value }) => {
                            onChange({
                                ...personales,
                                apellidoMaterno: capitalizar(value),
                            });
                        }}
                        fluid
                    />
                </Form.Group>
            </div>
        );
    }
}

export default Personales;



// WEBPACK FOOTER //
// ./src/modulos/Matriculas/IngresoNuevaMatricula/componentes/Personales/index.tsx